// extracted by css-extract-rspack-plugin
export default {"row":"LQrCC","label":"HuPwj","link":"asYuS"};